module.exports = __webpack_public_path__ + "img/chev_right.da209d74.svg";